// Labels and colours for VERI*FACTU states (English). Owned by the main session.

// Record status (verifactu_records.status)
export const RECORD_STATUS = {
  pending: { label: 'Pending', color: 'gold' },
  sending: { label: 'Sending', color: 'blue' },
  accepted: { label: 'Accepted', color: 'green' },
  accepted_with_errors: { label: 'Accepted with errors', color: 'orange' },
  rejected: { label: 'Rejected', color: 'red' },
  error_submission: { label: 'Submission error', color: 'red' },
  error_config: { label: 'Configuration error', color: 'volcano' },
  superseded: { label: 'Superseded', color: 'default' },
};

// Invoice summary status (invoices.verifactu.status)
export const INVOICE_STATUS = {
  queued: { label: 'Queued', color: 'gold' },
  blocked: { label: 'Blocked', color: 'red' },
  pending: { label: 'Pending', color: 'gold' },
  sending: { label: 'Sending', color: 'blue' },
  accepted: { label: 'Accepted', color: 'green' },
  accepted_with_errors: { label: 'Accepted with errors', color: 'orange' },
  rejected: { label: 'Rejected', color: 'red' },
  error: { label: 'Error', color: 'red' },
  cancelled: { label: 'Cancelled', color: 'default' },
};

export const RECORD_TYPE = {
  alta: 'Registration',
  anulacion: 'Cancellation',
};

export const MODE = {
  not_configured: 'Not configured',
  verifactu: 'VERI*FACTU',
  excluded: 'Excluded',
  not_issuer: 'Not an issuer',
};

export const ENVIRONMENT = {
  preprod: 'Test (AEAT pre-production)',
  prod: 'Production',
};

export const EXCLUSION_REASONS = {
  sii: 'Company under SII (Immediate Supply of Information)',
  foral_pv: 'Company under the Basque Country foral tax regime',
  foral_navarra: 'Company under the Navarre foral tax regime',
  outside_spain: 'Company established outside Spain',
  art5_rd1007: "'Non-application' request under Art. 5 RD 1007/2023 (unverified)",
};

// Spanish legal text printed on the invoice PDF when the company is excluded.
export const EXCLUSION_REASONS_ES = {
  sii: 'acogida al SII',
  foral_pv: 'acogida a la Hacienda Foral del País Vasco',
  foral_navarra: 'acogida a la Hacienda Foral de Navarra',
  outside_spain: 'situada fuera del territorio español',
  art5_rd1007: "solicitud de 'No aplicación' art. 5 RD 1007/2023",
};

export function recordStatusMeta(status) {
  return RECORD_STATUS[status] || { label: status || '—', color: 'default' };
}

export function invoiceStatusMeta(status) {
  return INVOICE_STATUS[status] || { label: status || '—', color: 'default' };
}

/** True when the invoice is registered (has a record) and must not be edited or deleted. */
export function isRegistered(invoice) {
  return !!(invoice && invoice.verifactu && invoice.verifactu.recordId);
}

/** Credit-note (Abonos) series. */
export const CREDIT_NOTE_SERIES = ['3', '4', '6', '8', '10', '12'];

/** QR must be printed on this PDF? (D10: only prod records; never notes or albaranes) */
export function shouldPrintQr(invoice, invoiceType) {
  return !!(
    invoice &&
    invoice.type === 'invoice' &&
    invoiceType !== 'albaran' &&
    invoice.verifactu &&
    invoice.verifactu.qrUrl &&
    invoice.verifactu.env === 'prod'
  );
}
